<script lang="ts">
    import { getCachedEntries } from "../../../api"
    import MedialibImage from "../MedialibImage.svelte"
    import Cta from "./widgets/CTA.svelte"
    import MiniLoader from "./widgets/MiniLoader.svelte"

    export let block: ContentBlock<"detailPagesPreview">
    const getPreviewEntries: () => Promise<ContentEntryTypeDetailPage[]> = async () =>
        // @ts-ignore
        getCachedEntries<"content">(
            "content",
            {
                "detailPage.type": block.detailPagesPreview.type.slice(0, -1),
            },
            "detailPage.order"
        )
</script>

{#await getPreviewEntries()}
    <MiniLoader />
{:then detailPages}
    <div class="list-wrapper">
        {#if block.detailPagesPreview.amountLimited}
            <h2>
                {block.detailPagesPreview.type == "practiceAreas" ? "Rechtsgebiete" : "Leistungen"}
                <Cta white="{true}" path="{block.detailPagesPreview.detailedPagesOverviewPath}">alle Rechtsgebiete</Cta>
            </h2>
        {/if}
        <ul class="cardWrapper">
            {#each detailPages as detailPage, i}
                {#if detailPage && (!block.detailPagesPreview.amountLimited || i < 6)}
                    <li>
                        <div class="header">
                            <span class="normal"> <MedialibImage id="{detailPage.detailPage.icon}" /></span>
                            <span class="hover"> <MedialibImage id="{detailPage.detailPage.iconHover}" /></span>
                            <h3>{detailPage.detailPage.title}</h3>
                        </div>
                        <div class="content">
                            <div class="upper">
                                <div>
                                    <p>{detailPage.detailPage.shortDescription}</p>
                                </div>
                            </div>
                            <div class="lower">
                                <Cta path="{detailPage.detailPage.detailedPage}">mehr lesen</Cta>
                            </div>
                        </div>
                    </li>
                {/if}
            {/each}
        </ul>
    </div>
{/await}

<style lang="less">
    @import "../../../css/variables.less";
    .list-wrapper {
        display: flex;
        flex-direction: column;
        gap: var(--default-gap);
        h2 {
            display: flex;
            width: 100%;
            justify-content: space-between;
            @media @mobile {
                flex-direction: column;
                gap: 10px;
            }
        }
        ul {
            color: var(--blue-100);
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
            @media @max-tablet {
                grid-template-columns: 1fr 1fr;
            }
            @media @mobile {
                grid-template-columns: 1fr;
            }
            gap: var(--default-gap);
            li {
                &:hover {
                    .upper {
                        transform: translateY(-0.6rem);
                    }
                    .header {
                        span.normal {
                            display: none !important;
                        }
                        span.hover {
                            display: block !important;
                        }
                    }
                }
                .header {
                    display: flex;
                    flex-direction: column;
                    gap: calc(var(--default-gap) / 2);
                    span {
                        height: 64px;
                        width: 64px;
                        display: none;
                        &.normal {
                            display: block;
                        }
                    }
                    @media @mobile {
                        span {
                            height: 48px;
                            width: 48px;
                        }
                    }
                }
                border-radius: 24px 6px 6px 6px;
                background: var(--white-100);
                box-shadow: 0px 0px 48px 0px rgba(89, 103, 111, 0.24);
                padding: calc(var(--default-gap) / 2) var(--default-gap);
                display: flex;
                flex-direction: column;
                gap: var(--default-gap);
                .content {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    flex-grow: 1;
                    gap: var(--default-gap);
                    .upper {
                        display: flex;
                        flex-direction: column;
                        gap: var(--default-gap);
                        transition: transform 0.3s ease-out;
                    }
                    .lower {
                        display: flex;
                    }
                }
            }
        }
    }
</style>
